/**
 * DialRecordingContainer component.
 */
import Screen from '@shared/utils/screen';
import styled from 'styled-components';
import withOpacity from '@shared/components/utils/hoc/withOpacity';

/**
 * Styled dial recording container.
 */
const DialRecordingContainer = styled.div<React.CSSProperties>`
  left: ${72 * Screen.widthRatio}px;
  position: absolute;
  top: ${88 * Screen.widthRatio}px;
  z-index: 1;
`;

export default withOpacity(DialRecordingContainer);
